import { Navigate, Route, Routes, resolvePath, useLocation } from 'react-router-dom';

import Transaction from './transaction';

export default function RewardReceivedPage() {
  const location = useLocation();

  return (
    <Routes>
      <Route element={<Transaction />} path=":transaction_id/*" />
      <Route element={<Navigate to={resolvePath('..', location.pathname)} />} path="*" />
    </Routes>
  );
}
